export const SIGN_OUT_TEXT = 'ログアウト'
export const UNKNOWN_ERROR_TEXT = '原因不明のエラー'

export const codeList: { [key: number]: string } = {
  401: '未ログイン状態になっているか、トークンが無効になっています。ログインし直してください。',
  404: 'ファイルが見つかりませんでした',
  500: 'サーバーエラーが発生しました',
}
